/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomFullProductResponseDto } from '../models/pom-full-product-response-dto';


/**
 * the Product full API
 */
@Injectable({
  providedIn: 'root',
})
export class ProductFullService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fetchActiveProductByCode
   */
  static readonly FetchActiveProductByCodePath = '/product/{productCode}';

  /**
   * Get full graph of active product
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fetchActiveProductByCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetchActiveProductByCode$Response(params: {
    productCode: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomFullProductResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductFullService.FetchActiveProductByCodePath, 'get');
    if (params) {
      rb.path('productCode', params.productCode, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomFullProductResponseDto>;
      })
    );
  }

  /**
   * Get full graph of active product
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fetchActiveProductByCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetchActiveProductByCode(params: {
    productCode: string;
  },
  context?: HttpContext

): Observable<PomFullProductResponseDto> {

    return this.fetchActiveProductByCode$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomFullProductResponseDto>) => r.body as PomFullProductResponseDto)
    );
  }

  /**
   * Path part for operation fetchProductByInternalId
   */
  static readonly FetchProductByInternalIdPath = '/product/{internalId}/full';

  /**
   * Get full product by internal id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fetchProductByInternalId()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetchProductByInternalId$Response(params: {
    internalId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomFullProductResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductFullService.FetchProductByInternalIdPath, 'get');
    if (params) {
      rb.path('internalId', params.internalId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomFullProductResponseDto>;
      })
    );
  }

  /**
   * Get full product by internal id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fetchProductByInternalId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetchProductByInternalId(params: {
    internalId: string;
  },
  context?: HttpContext

): Observable<PomFullProductResponseDto> {

    return this.fetchProductByInternalId$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomFullProductResponseDto>) => r.body as PomFullProductResponseDto)
    );
  }

}
